module.exports = __webpack_public_path__ + "media/images/psp/swiss/logo/star-alliance-b48aad79b77e4fe92a13c56a406376fe.svg";